import { DefaultError, useMutation } from "@tanstack/react-query";
import { createBulletin } from "../api/createBulletin";
import { invalidateBulletinListQuery } from "../queries/useBulletinListQuery";
import { BulletinDataToCreate } from "../types";

type Params = {
  data: BulletinDataToCreate;
};

export const useCreateBulletinMutation = (onSuccess: () => void) => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async ({ data }) => {
      await createBulletin(data);
    },
    onSuccess: () => {
      invalidateBulletinListQuery();
      onSuccess();
    },
    onError: (e) => {
      console.error("Error occurred when creating bulletin", e);
    },
  });
};
